import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toFullName' })
export class NamePipe implements PipeTransform {
  transform(value: { given_name: string, family_name: string }): string {
    if (value) {
      return `${value.given_name} ${value.family_name}`;
    } else {
      return '';
    }
  }
}
